import PropTypes from 'prop-types';
import React from 'react';
import PlaylistItem from './PlaylistItem';
import { STATUS } from '../../constants/result';

const Playlist = (props) => (
    <div className="measure-progression">
        {props.playlistForRender.map((item, index) => (
            <PlaylistItem
                key={`playlist-item-${item.key}`}
                index={index + 1}
                name={item.name}
                measure={item.measure}
                isComplete={item.status === STATUS.COMPLETED} />
        ))}
    </div>
);

Playlist.propTypes = {
    playlistForRender: PropTypes.array.isRequired,
};

export default Playlist;
